var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('delete-modal',{attrs:{"title":_vm.title,"text":_vm.content},on:{"onclickItem":_vm.deleteWidget,"close":function($event){return _vm.eventHub.$emit('setWidgetFinished')}}})}
var staticRenderFns = []

export { render, staticRenderFns }